import mixins from 'vue-typed-mixins';

import Header from '@/user/components/header/Header.vue';
import BackButton from '@/user/components/header/backButton/BackButton.vue';
import LogoutButton from '@/user/components/header/logoutButton/LogoutButton.vue';
import UserStamp from '@/user/components/userStamp/UserStamp.vue';

import RoutesMixin from '@/user/mixins/RoutesMixin';
import UserMixin from '@/user/mixins/UserMixin';

import UserApiUtility from '@/classes/common/UserApiUtility';
import { UserStamps } from '@/classes/definition/UserStamp';




export default mixins(RoutesMixin, UserMixin).extend({

  name: 'StampSelect',

  components: {
    Header,
    BackButton,
    LogoutButton,
    UserStamp,
  },

  data(): {
    visibleDialog: boolean;
    stamps: string[];
    selectedStamp: string;
  } {
    return {
      visibleDialog: false,
      stamps: UserStamps,
      selectedStamp: UserStamps[0],
    };
  },

  methods: {
    isSelected(stamp: string): boolean {
      return this.userStamp === stamp;
    },
    async chooseStamp(stamp: string): Promise<void> {
      if (this.isSelected(stamp)) return;
      this.selectedStamp = stamp;
      this.visibleDialog = true;
    },
    async decide(): Promise<void> {
      if (this.isGuest) {
        this.setUserStamp(this.selectedStamp);
      } else {
        await UserApiUtility.getUserApi().updateUserStamp({ userStamp: this.selectedStamp });
        await this.loadUserState(true);
      }

      this.visibleDialog = false;
    },
    back(): void {
      this.$router.push(this.routes.CourseSelect);
    },
  },

});
